<template>
  <div class="body-wrapper">
    <div>
      <h4>Obaveze</h4>
      <div class="table-wrapper">
        <spinner class="spinner" line-fg-color="#00796b" :size="100" :line-size="6" v-if="loading"></spinner>
        <div v-show="!loading">
          <div class="btns-wrapper">
            <button class="btn btn-primary" @click="showModal('ModalContentExpense')">
              <span>Nova obaveza</span>
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <data-table
            :columns="tableColumns"
            :tableData="tableData"
            :options="tableOptions"
            :slotNameActionCommunityFinancesExpenses="'action'"
            :slotExpensePrice="'price'"
          ></data-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/community/Table';
import axios from '@/axios/axios.js';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  components: {
    DataTable
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('finances', ['expenses']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  async created() {
    this.setTableBadge('fas fa-cash-register');
    //setting up table options and table column names
    this.initTable('communityFinancesExpensesTable');
    await this.getTableData({
      communityId: this.$store.getters.getActiveCommunity.id,
      tableName: 'expenses'
    });
    this.setTableData(this.expenses.data);
  },
  methods: {
    ...mapActions('table', ['initTable']),
    ...mapActions('finances', ['getTableData']),
    ...mapMutations('modal', ['showModal']),
    ...mapMutations('table', ['setTableBadge', 'setTableData'])
  },
  destroyed() {
    //unsetting table badge
    this.setTableBadge('');
  }
};
</script>
<style lang="scss" scoped>
h4 {
  position: relative;
  margin-bottom: 1rem;
  // &:after {
  //   content: '';
  //   position: absolute;
  //   left: 2px;
  //   bottom: -2px;
  //   width: 5%;
  //   border-bottom: 2px solid black;
  // }
}
.btns-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  .btn {
    width: 170px;
    margin-right: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
